<script>
  // components
  import TwoColumnRow from './TwoColumnRow.svelte';

  /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
  export let races;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  // export let crosswalk;
  // $: race = race
  // $: totalVotes = $race.total_votes;
</script>

<table class="summary-results">
  <thead>
    <tr>
      <th scope="col" class="sticky-top text-center"> District </th>
      <th colSpan={2} scope="col" class="sticky-top"> candidates </th>
      <!-- <th scope="col" class="sticky-top summary-results__separator desktop-only">Third</th> -->
      <th scope="col" class="text-right sticky-top">
        % In<span class="invisible"></span>
      </th>
    </tr>
  </thead>
  <tbody>
    {#each $races as r}
    {#if r.seat_number != 0}
        <TwoColumnRow 
        candidates = {r.candidates}
        districtNumber={r.seat_number}
        isUncontested={r.is_uncontested}
        eevp={r.eevp}
        totalVotes={r.total_votes}
        />
    {/if}
    {/each}
  </tbody>
</table>

